import { GET_LOADER_STATUS } from './types';


export const getLoaderStatusAction = (loaderStatus) => dispatch => {
    dispatch({
        type: GET_LOADER_STATUS,
        loaderStatus: loaderStatus,
    })

}
